import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import './styles.css'
import { useNavigate } from 'react-router-dom'
import deleteIcon from '../../../assets/images/trash.svg'
import editIcon from '../../../assets/images/editIcon.svg'
import eyeIcon from '../../../assets/images/eye.svg'
import { deleteBanner } from '../../../redux/bannerItemSlice.js'
import Carousel from 'react-bootstrap'
import BannerPopup from './BannerPopUp.js'
import { toast } from 'react-hot-toast'
import WarningShipmentModalComponent from '../../../components/Modals/WarningShipmentModalComponent.js'

const BannerCard = ({ banner, isDeleted, setIsDeleted }) => {
    const navigate = useNavigate()
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(false)
    const [deleteModal, setDeletedModal] = useState(false)
    const dispatch = useDispatch()
    const handleEditBanner = () => {
        navigate(`../banner/edit`, {
            state: {
                bannerId: banner.bannerId
            }
        })
    }
    const handleShow = () => {
        setShow(true)
    }

    const onDeleteModalClose = () => {
        setDeletedModal(false)
    }

    const handleDelete = async () => {
        setLoading(true)
        try {
            const resp = await deleteBanner(banner.bannerId)
            setIsDeleted(true)
        } catch (err) {
            setError(true)
            console.log(err)
        }
        setLoading(false)
    }

    setIsDeleted(false)

    const imageUrl = 'http://localhost:3200/' + banner.bannerImagePath

    return (
        <div className='banner_card banner-dot banner-stage'>
            <div className='d-flex'>
                <img src={imageUrl} style={{
                    width: '132px',
                    height: '111px',
                    borderRadius: '12px'
                }} />
                <div className='banner_body'>
                    <p className='banner_header'>{banner.bannerHeader}</p>
                    {banner.bannerText != '' ?
                        <p className='banner_description'>
                            {banner.bannerText}
                        </p>
                        : <p className='banner_description'>
                            No Description Provided
                        </p>}
                    <p className='banner_status'>{banner.bannerStatus}</p>
                    <div className='clays-sm'>
                        <button className='icon-clay' onClick={handleShow} >
                            <span class="inner-clay color-black"><img src={eyeIcon} alt="View" />
                            </span>
                        </button>
                        <button className='icon-clay' onClick={handleEditBanner} >
                            <span class="inner-clay color-black"><img src={editIcon} alt="View" />
                            </span>
                        </button>
                        <button className='icon-clay' onClick={() => setDeletedModal(true)}>
                            <span class="inner-clay color-black"><img src={deleteIcon} alt="View" />
                            </span>
                        </button>
                    </div>
                </div>
                <div>
                    <BannerPopup show={show} banner={banner} handleShow={setShow} imageUrl={imageUrl} />
                </div>
                <WarningShipmentModalComponent isOpen={deleteModal} onClose={onDeleteModalClose} handleDelete={handleDelete} />
            </div>
        </div>
    )
}

export default BannerCard